<template>
  <div>
    <div class="bottom_btn_inner">
      <nut-button
        @click="clickBtn('prv')"
        class="one_btn_normal"
        :class="[showTwoBtn ? 'width50' : 'width100']"
        v-if="showTwoBtn"
      >
        {{ oneBtnName }}
      </nut-button>
      <nut-button
        @click="clickBtn('next')"
        class="two_btn_normal"
        :class="[
          userSelectEnd ? 'select_btn' : 'no_select_btn',
          showTwoBtn ? 'width50' : 'width100',
        ]"
      >
        {{ twoBtnName }}
      </nut-button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    showTwoBtn: {
      type: Boolean,
      default: false,
    },
    oneBtnName: {
      type: String,
      default: "下一题",
    },
    twoBtnName: {
      type: String,
      default: "提交",
    },
    userSelectEnd: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const clickBtn = (type) => {
      if (props.userSelectEnd != true && type == "next") return;
      ctx.emit("clickBtnEvent", type);
    };
    return {
      clickBtn,
    };
  },
});
</script>
<style lang="scss" scoped>
.bottom_btn_inner {
  margin: 0 auto;
  width: 320px;
  height: 42px;
}
.one_btn_normal {
  height: 42px;
  background: #ffffff;
  border: 1px solid #0088ff;
  border-radius: 21px;
  font-weight: Bold;
  font-size: 16px;
  color: #0088ff;
  text-align: center;
  line-height: 16px;
  margin-right: 10px;
  &:foucs{ 
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }
}
.two_btn_normal {
  background: #0088ff;
  border: 0;
  border-radius: 21px;
  height: 42px;
  text-align: center;
  color: #fff;
  font-weight: Bold;
  font-size: 16px;
  text-align: center;
  line-height: 16px;
  &:foucs{ 
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }
}
.no_select_btn {
  opacity: 0.4;
}
.select_btn {
  opacity: 1;
}
.width50 {
  // width: 155px;
  width: 48%;
  box-sizing: border-box;
}
.width100 {
  width: 100%;
}
</style>
